module.exports = __webpack_public_path__ + "static/media/provider_playngo.e1d35be5.jpg";